import {
  Add,
  ArrowRightOutlined,
  DeleteOutlineOutlined,
  Edit,
  GridView,
  Info,
  Search,
  Tune,
} from "@mui/icons-material";
import {
  FormControl,
  IconButton,
  MenuItem,
  Paper,
  Select,
  TextField,
  Tooltip,
  InputLabel,
} from "@mui/material";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router";
import axios from "axios";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import DeleteModal from "../../components/Modals/DeleteModal";
import NotFound from "../../components/SharedModule/NotFound";

const Tables = () => {

  const { user } = useSelector((state) => state.auth);

  const token = user?.token;

  const newBaseUrl = "https://estbn.com/EstbnNew/public";

  const headers = {
    Authorization: "Bearer " + token,
  };

  const [viewMode, setViewMode] = useState("cards");

  const [searchTerm, setSearchTerm] = useState("");

  const [viewBy, setViewBy] = useState("All Equipment");

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const navigate = useNavigate();

  const handleViewByChange = (event) => {
    const selectedValue = event.target.value;
    setViewBy(selectedValue);

    if (selectedValue === "Sub Categories") {
      navigate(`/subcategory`);
    } else if (selectedValue === "Models") {
      navigate(`/EQmodal`);
    } else if (selectedValue === "Main Categories") {
      navigate(`/equipments`);
    }
  };

  // add & update modal functions & declarations

  const [isEditing, setIsEditing] = useState(false);

  const [editEquipmentId, setEditEquipmentId] = useState(null);

  const [equipmentsFormData, setEquipmentsFormData] = useState([]);

  const getEquipmentsFormData = async () => {
    try {
      let response = await axios.get(
        `${newBaseUrl}/api/portal/equipments/form/data`,
        {
          headers,
        }
      );
      console.log(response.data.data);
      setEquipmentsFormData(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const [addEquipmentData, setAddEquipmentData] = useState({
    model_id: "",
    internal_serial_number: "",
    manufacturer_serial_number: "",
    status: "",
    acquisition_type: "",
    purchase_date: "",
    warranty_expiry: "",
    rental_end_date: "",
    notes: "",
  });

  const [show, setShow] = useState(false);

  const handleShow = () => {
    setAddEquipmentData({
      model_id: "",
      internal_serial_number: "",
      manufacturer_serial_number: "",
      status: "",
      acquisition_type: "",
      purchase_date: "",
      warranty_expiry: "",
      rental_end_date: "",
      notes: "",
    });
    setIsEditing(false);
    setEditEquipmentId(null);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setIsEditing(false);
    setEditEquipmentId(null);
  };

  const onSubmitAddEquipment = () => {
    const formData = new FormData();

    if (isEditing) {
      formData.append("_method", "PATCH");
    }

    formData.append("model_id", addEquipmentData.model_id);
    formData.append(
      "internal_serial_number",
      addEquipmentData.internal_serial_number
    );
    formData.append("status", addEquipmentData.status);
    formData.append(
      "manufacturer_serial_number",
      addEquipmentData.manufacturer_serial_number
    );
    formData.append("acquisition_type", addEquipmentData.acquisition_type);
    formData.append("purchase_date", addEquipmentData.purchase_date);
    formData.append("warranty_expiry", addEquipmentData.warranty_expiry);
    formData.append("rental_end_date", addEquipmentData.rental_end_date || "");
    formData.append("notes", addEquipmentData.notes);

    const url = isEditing
      ? `${newBaseUrl}/api/portal/equipments/${editEquipmentId}`
      : `${newBaseUrl}/api/portal/equipments`;

    axios
      .post(url, formData, { headers })
      .then((response) => {
        console.log(response.data);
        toast.success(
          isEditing
            ? "Equipment Updated Successfully"
            : "Equipment Added Successfully",
          { autoClose: 3000 }
        );
        setShow(false);
        setIsEditing(false);
        getEquipments();
        setAddEquipmentData({
          model_id: "",
          internal_serial_number: "",
          manufacturer_serial_number: "",
          status: "",
          acquisition_type: "",
          purchase_date: "",
          warranty_expiry: "",
          rental_end_date: "",
          notes: "",
        });
      })
      .catch((error) => {
        toast.error(error.response.data.message, { autoClose: 3000 });
      });
  };

  const handleEditEquipment = (equipment) => {
    console.log(equipment);
    setAddEquipmentData({
      model_id: equipment?.model?.id || "",
      internal_serial_number: equipment?.internal_serial_number || "",
      manufacturer_serial_number: equipment?.manufacturer_serial_number || "",
      status: equipment?.status || "",
      acquisition_type: equipment?.acquisition_type || "",
      purchase_date: equipment?.purchase_date || "",
      warranty_expiry: equipment?.warranty_expiry || "",
      rental_end_date: equipment?.rental_end_date || "",
      notes: equipment?.notes || "",
    });
    setValue("model_id", equipment?.model?.id || "");
    setValue("internal_serial_number", equipment?.internal_serial_number || "");
    setValue(
      "manufacturer_serial_number",
      equipment?.manufacturer_serial_number || ""
    );
    setValue("status", equipment?.status || "");
    setValue("acquisition_type", equipment?.acquisition_type || "");
    setValue("purchase_date", equipment?.purchase_date || "");
    setValue("warranty_expiry", equipment?.warranty_expiry || "");
    setValue("rental_end_date", equipment?.rental_end_date || "");
    setValue("notes", equipment?.notes || "");
    setIsEditing(true);
    setEditEquipmentId(equipment.id);
    setShow(true);
  };

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors, isSubmitting },
  } = useForm();

  // delete modal functions

  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [itemToDelete, setItemToDelete] = useState(null);

  const handleDeleteClick = (id) => {
    setItemToDelete(id);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = async () => {
    try {
      let response = await axios.delete(
        `${newBaseUrl}/api/portal/equipments/${itemToDelete}`,
        {
          headers,
        }
      );
      toast.warning("Equipment Deleted successfully", { autoClose: 3000 });
      console.log(response);
      handleCloseDeleteModal();
      getEquipments();
    } catch (error) {
      toast.error(error.response.data?.errors?.message);
    }
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setItemToDelete(null);
  };

  // equipments data

  const [equipments, setEquipments] = useState([]);

  const [rowCount, setRowCount] = useState(null);

  const [paginationModel, setPaginationModel] = useState({
  page: 0,
  pageSize: 15,
});

  const getEquipments = async (page = 1, perPage = 15) => {
    try {
      let response = await axios.get(
        `${newBaseUrl}/api/portal/equipments?page=${page}&per_page=${perPage}`,
        {
          headers,
        },
      );
      console.log(response.data.data.equipment);
      setEquipments(response.data.data.equipment);
       setRowCount(response.data.data.pagination.total);
    } catch (error) {
      console.log(error);
    }
  };

  const columns = [
    {
      field: "reference",
      headerName: "Reference No.",
      flex: 1.4,
      minWidth: 180,
      renderCell: (params) => (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            whiteSpace: "normal",
            overflowWrap: "anywhere",
            wordBreak: "break-word",
            textAlign: "center",
            lineHeight: "18px",
            fontWeight: 600,
          }}
        >
          {params.value || "-"}
        </div>
      ),
    },
    {
      field: "model",
      headerName: "Model",
      flex: 1.4,
      minWidth: 180,
      renderCell: (params) => (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            whiteSpace: "normal",
            overflowWrap: "anywhere",
            wordBreak: "break-word",
            lineHeight: "18px",
          }}
        >
          {params.value || "-"}
        </div>
      ),
    },
    {
      field: "original",
      headerName: "Original Serial No.",
      flex: 1.4,
      minWidth: 180,
      renderCell: (params) => (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            whiteSpace: "normal",
            overflowWrap: "anywhere",
            wordBreak: "break-word",
            lineHeight: "18px",
          }}
        >
          {params.value || "-"}
        </div>
      ),
    },
    {
      field: "estbn",
      headerName: "Estbn Serial No.",
      flex: 1,
      minWidth: 130,
    },
    {
      field: "category",
      headerName: "Category",
      flex: 1,
      minWidth: 110,
    },
    {
      field: "subCategory",
      headerName: "Sub Category",
      flex: 0.6,
      minWidth: 100,
    },
    {
      field: "conditions",
      headerName: "Conditions",
      flex: 1,
      minWidth: 130,
      renderCell: (params) => {
        return (
          <div>
            {params.row.conditions.length > 0 ? params.row.conditions : "-"}
          </div>
        );
      },
    },

    {
      field: "acquisition",
      headerName: "Acquisition",
      flex: 0.9,
      minWidth: 90,
    },
    {
      field: "status",
      headerName: "Status",
      flex: 0.9,
      minWidth: 90,
    },
    {
      field: "warranty",
      headerName: "Warranty",
      flex: 0.9,
      minWidth: 90,
    },

    {
      field: "date",
      headerName: "Date",
      flex: 0.9,
      minWidth: 90,
    },
    {
      field: "Actions",
      headerName: "Actions",
      flex: 1,
      minWidth: 120,
      renderCell: (params) => {
        const equi = params.row.rawData;
        return (
          <div className="d-flex justify-content-evenly align-items-center h-100 w-100">
            <IconButton
              sx={{ color: "" }}
              aria-label="edit"
              size="small"
              style={{ width: "25%" }}
              onClick={(e) => {
                e.stopPropagation();
                handleEditEquipment(equi);
              }}
            >
              <Edit />
            </IconButton>
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                handleDeleteClick(params.id);
              }}
              aria-label="delete"
              size="small"
              style={{ width: "25%" }}
              color="error"
            >
              <DeleteOutlineOutlined />
            </IconButton>
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                navigate(`/AllEquipments/${params.id}`);
              }}
              aria-label="navigate"
              size="small"
              style={{ width: "25%" }}
              color="default"
            >
              <ArrowRightOutlined />
            </IconButton>
          </div>
        );
      },
    },
  ];

  //  filter functions

  const [showFilter, setShowFilter] = useState(false);

  const [selectedStatuses, setSelectedStatuses] = useState([]);

  const [selectedAcquisitions, setSelectedAcquisitions] = useState([]);

  const [filteredEquipments, setFilteredEquipments] = useState(null);

  const toggleFilter = () => {
    setShowFilter(!showFilter);
  };

  const handleStatusChange = (value) => {
    setSelectedStatuses((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]
    );
  };

  const handleAcquisitionChange = (value) => {
    setSelectedAcquisitions((prev) =>
      prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]
    );
  };

  const applyFilters = () => {
    // if nothing selected, reset to show all equipments
    if (selectedStatuses.length === 0 && selectedAcquisitions.length === 0) {
      setFilteredEquipments(null);
      setShowFilter(false);
      return;
    }

    let filtered = equipments;

    if (selectedStatuses.length > 0) {
      filtered = filtered.filter((eq) => selectedStatuses.includes(eq.status));
    }

    if (selectedAcquisitions.length > 0) {
      filtered = filtered.filter((eq) =>
        selectedAcquisitions.includes(eq.acquisition_type)
      );
    }

    // Set filtered equipments (even if empty)
    setFilteredEquipments(filtered);
    setShowFilter(false);
  };

  const equipmentsToDisplay =
    filteredEquipments === null ? equipments : filteredEquipments;

  const rows = equipmentsToDisplay.map((eq) => ({
    id: eq.id,
    reference: eq.reference,
    model: eq.model?.name || "Unknown",
    original: eq.manufacturer_serial_number || "Unknown",
    category: eq.model?.category?.name || "Unknown",
    subCategory: "-",
    conditions: eq.conditions,

    estbn: eq.internal_serial_number || "Unknown",
    acquisition: eq.acquisition_type || "Unknown",
    status: eq.status || "Unknown",
    warranty: new Date(eq.warranty_expiry).toLocaleDateString() || "Unknown",
    date: new Date(eq.purchase_date).toLocaleDateString() || "Unknown",
    Actions: "",
    rawData: eq,
  }));

  // effects

  useEffect(() => {
    setViewMode("cards");
    getEquipmentsFormData();
  }, []);

  useEffect(() => {
    getEquipments(paginationModel.page + 1, paginationModel.pageSize);
  }, [paginationModel]);

  return (
    <>
      {/* add equipment modal */}
      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header className="categories_header">
          <Modal.Title className="categories_title d-flex justify-content-between align-items-center">
            {isEditing ? "Edit Equipment" : "Add Equipment"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit(onSubmitAddEquipment)}>
            {/* serial numbers & status */}
            <div className="row">
              {/* original serial number  */}
              <div className="col-4">
                <TextField
                  className="w-100 mb-4"
                  label="Original Serial Number "
                  variant="outlined"
                  {...register("manufacturer_serial_number")}
                  value={addEquipmentData.manufacturer_serial_number}
                  onChange={(e) => {
                    setAddEquipmentData({
                      ...addEquipmentData,
                      manufacturer_serial_number: e.target.value,
                    });
                  }}
                />
                {errors.manufacturer_serial_number && (
                  <p className="danger">
                    {errors.manufacturer_serial_number.message}
                  </p>
                )}
              </div>
              {/* estbn serial number  */}
              <div className="col-4">
                <TextField
                  className="w-100 mb-4"
                  label="ESTBN Serial Number"
                  variant="outlined"
                  {...register("internal_serial_number")}
                  value={addEquipmentData.internal_serial_number}
                  onChange={(e) => {
                    setAddEquipmentData({
                      ...addEquipmentData,
                      internal_serial_number: e.target.value,
                    });
                  }}
                />
                {errors.internal_serial_number && (
                  <p className="danger">
                    {errors.internal_serial_number.message}
                  </p>
                )}
              </div>
              {/* status */}
              <div className="col-4">
                <FormControl className="w-100 mb-4" variant="outlined">
                  <InputLabel id="status-label">Status</InputLabel>
                  <Select
                    labelId="status-label"
                    label="Status"
                    {...register("status")}
                    value={addEquipmentData.status}
                    onChange={(e) => {
                      setAddEquipmentData({
                        ...addEquipmentData,
                        status: e.target.value,
                      });
                    }}
                  >
                    {equipmentsFormData?.status_options &&
                      Object.entries(equipmentsFormData?.status_options).map(
                        ([key, value]) => (
                          <MenuItem
                            key={key}
                            className="custom-menu-item"
                            value={key}
                          >
                            {value}
                          </MenuItem>
                        ),
                      )}
                  </Select>
                </FormControl>
                {errors.status && (
                  <p className="danger">{errors.status.message}</p>
                )}
              </div>
            </div>
            {/* waranty , date & Acquisition Type */}
            <div className="row">
              {/* waranty */}
              <div className="col-4">
                <TextField
                  className="w-100"
                  label="Warranty"
                  type="date"
                  value={addEquipmentData.warranty_expiry}
                  {...register("warranty_expiry")}
                  onChange={(e) =>
                    setAddEquipmentData({
                      ...addEquipmentData,
                      warranty_expiry: e.target.value,
                    })
                  }
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </div>
              {/* purchase date  */}
              <div className="col-4">
                <TextField
                  className="w-100"
                  label="Date"
                  type="date"
                  value={addEquipmentData.purchase_date}
                  {...register("purchase_date")}
                  onChange={(e) =>
                    setAddEquipmentData({
                      ...addEquipmentData,
                      purchase_date: e.target.value,
                    })
                  }
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </div>
              {/* Acquisition Type */}
              <div className="col-4">
                <FormControl className="w-100 mb-4" variant="outlined">
                  <InputLabel id="Acquisition-Type ">
                    Acquisition Type
                  </InputLabel>
                  <Select
                    labelId="Acquisition-Type"
                    label="Acquisition Type "
                    {...register("acquisition_type")}
                    value={addEquipmentData.acquisition_type}
                    onChange={(e) => {
                      setAddEquipmentData({
                        ...addEquipmentData,
                        acquisition_type: e.target.value,
                      });
                    }}
                  >
                    {equipmentsFormData?.acquisition_type_options &&
                      Object.entries(
                        equipmentsFormData?.acquisition_type_options,
                      ).map(([key, value]) => (
                        <MenuItem
                          key={key}
                          className="custom-menu-item"
                          value={key}
                        >
                          {value}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
                {errors.acquisition_type && (
                  <p className="danger">{errors.acquisition_type.message}</p>
                )}
              </div>
            </div>
            {/* model & rental-date */}
            <div className="row">
              <div className="col-6">
                <FormControl className="w-100 mb-4" variant="outlined">
                  <InputLabel id="model-id">Model</InputLabel>
                  <Select
                    labelId="model-id"
                    label="Model"
                    {...register("model_id")}
                    value={addEquipmentData.model_id}
                    onChange={(e) => {
                      setAddEquipmentData({
                        ...addEquipmentData,
                        model_id: e.target.value,
                      });
                    }}
                  >
                    {equipmentsFormData?.models &&
                      equipmentsFormData?.models.map((model) => (
                        <MenuItem
                          key={model.id}
                          className="custom-menu-item"
                          value={model.id}
                        >
                          {model.name}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
                {errors.acquisition_type && (
                  <p className="danger">{errors.acquisition_type.message}</p>
                )}
              </div>
            </div>
            {/* description  */}
            <TextField
              className="w-100 mb-4"
              label="Equipment Description"
              variant="outlined"
              rows={4}
              multiline
              {...register("notes")}
              value={addEquipmentData.notes}
              onChange={(e) => {
                setAddEquipmentData({
                  ...addEquipmentData,
                  notes: e.target.value,
                });
              }}
            />
            {errors.notes && <p className="danger">{errors.notes.message}</p>}
            {/* footer  */}
            <div className="categories_foterAddModel">
              <button
                type="button"
                className="categories_closAddModal"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isSubmitting}
                className="categories_saveAddModeal"
              >
                Save
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
      {/* delete modal */}
      <DeleteModal
        showDelete={showDeleteModal}
        handleDeleteClose={handleCloseDeleteModal}
        textMessage={" Are you sure you want to delete this Equipment ?"}
        deleteFunction={handleConfirmDelete}
      />
      {/* data */}
      <div className="m-4">
        {/* header */}
        <div className="d-flex justify-content-between align-items-center w-100">
          <h6 className="m-0">General Equipment</h6>
          <button onClick={handleShow} className="btn btn-light mx-1">
            <Add /> New Equipment
          </button>
        </div>
        {/* search & filters */}
        <div className="d-flex justify-content-between align-items-center w-100 my-4">
          <div className="input-group flex-nowrap justify-content-end align-items-center rounded-2 w-50">
            <input
              type="text"
              className="form-control bg-transparent position-relative rounded"
              placeholder="Search for equipment .."
              value={searchTerm}
              onChange={handleSearch}
            />
            <div className="position-absolute mx-2">
              <Search />
            </div>
          </div>

          <div className="d-flex align-items-center justify-content-end gap-2 w-50">
            <span>View by</span>

            <Select
              className="border"
              size="small"
              value={viewBy}
              onChange={handleViewByChange}
              displayEmpty
              sx={{ minWidth: 150 }}
            >
              <MenuItem
                className="custom-menu-item"
                value="Main Categories"
                key="Main Categories"
              >
                Main Categories
              </MenuItem>
              <MenuItem
                className="custom-menu-item"
                value="Sub Categories"
                key="Sub Categories"
              >
                Sub Categories
              </MenuItem>
              <MenuItem
                className="custom-menu-item"
                value="Models"
                key="Models"
              >
                Models
              </MenuItem>
              <MenuItem
                className="custom-menu-item"
                value="All Equipment"
                key="All Equipment"
              >
                All Equipment
              </MenuItem>
            </Select>
            <div className="">
              <button
                onClick={() => setViewMode("cards")}
                className={`btn ${
                  viewMode === "cards" ? "btn-dark" : "btn-light"
                }`}
              >
                <GridView />
              </button>
              <button
                onClick={() => setViewMode("table")}
                className={`btn ${
                  viewMode === "table" ? "btn-dark" : "btn-light"
                }`}
              >
                <FormatListBulletedIcon />
              </button>
            </div>

            <div className="">
              <button className="btn btn-light" onClick={toggleFilter}>
                <Tune />
              </button>
            </div>
          </div>
        </div>
        {/* cards view  */}
        {viewMode === "cards" && (
          <div className="row g-3">
            {filteredEquipments === null ? (
              equipments && equipments.length > 0 ? (
                equipments.map((eq) => (
                  <div className="col-12 col-lg-3">
                    <div
                      style={{
                        backgroundColor: "#F9F9F9",
                        height: "350px",
                        overflow: "auto",
                      }}
                      className="rounded-4 px-3 py-2 w-100"
                    >
                      <div className="d-flex justify-content-between align-items-center flex-wrap custom-card-sm gap-2 mt-1">
                        <div className="d-flex justify-content-center align-items-center custom-card-sm">
                          <IconButton
                            onClick={() => handleEditEquipment(eq)}
                            size="small"
                          >
                            <Edit />
                          </IconButton>
                        </div>
                        <div className="d-flex align-items-center gap-2">
                          <div className="cursor">
                            <IconButton
                              size="small"
                              color="error"
                              onClick={() => handleDeleteClick(eq.id)}
                            >
                              <DeleteOutlineOutlined />
                            </IconButton>
                          </div>
                        </div>
                      </div>
                      <div
                        onClick={() => navigate(`/AllEquipments/${eq.id}`)}
                        className="cursor"
                      >
                        <h6
                          style={{ fontSize: "15px" }}
                          className="fw-bold text-center my-1"
                        >
                          {eq?.model?.name}
                          <Tooltip
                            componentsProps={{
                              tooltip: { sx: { width: 150 } },
                            }}
                            title={eq?.notes}
                            placement="right"
                          >
                            <IconButton>
                              <Info sx={{ width: 20 }} />
                            </IconButton>
                          </Tooltip>
                        </h6>
                        <div className="d-flex flex-wrap justify-content-between align-items-center custom-card-sm ">
                          <p className="small my-1">Ref</p>
                          <p className="fw-semibold my-1">{eq?.reference}</p>
                        </div>
                        <div className="d-flex flex-wrap justify-content-between custom-card-sm ">
                          <p className="small my-1">ESTBN S/N.</p>
                          <p className="fw-semibold my-1">
                            {eq?.internal_serial_number}
                          </p>
                        </div>
                        <div className="d-flex flex-wrap justify-content-between custom-card-sm ">
                          <p className="small my-1">Acquisition</p>
                          <p className="fw-semibold my-1">
                            {eq?.acquisition_type_display}
                          </p>
                        </div>
                        <div className="d-flex flex-wrap justify-content-between align-items-center custom-card-sm ">
                          <p className="small my-1">Category</p>
                          <p className="fw-semibold my-1">
                            {eq?.model?.category?.name}
                          </p>
                        </div>
                        <div className="d-flex flex-wrap justify-content-between align-items-center custom-card-sm ">
                          <p className="small my-1">Sub Category</p>
                          <p className="fw-semibold my-1">-</p>
                        </div>
                        <div className="d-flex flex-wrap justify-content-between align-items-center custom-card-sm ">
                          <p className="small my-1">Condition</p>
                          {eq.current_condition_status ? (
                            <p className="fw-semibold my-1">
                              {eq.current_condition_status?.status}
                            </p>
                          ) : (
                            "-"
                          )}
                        </div>
                        <div className="d-flex flex-wrap justify-content-between align-items-center custom-card-sm ">
                          <p className="small my-1">Status</p>
                          <p className="fw-semibold my-1">
                            {eq?.status_display}
                          </p>
                        </div>
                        {/* <div className="d-flex flex-wrap justify-content-between align-items-center custom-card-sm ">
                          <p className="small my-1">Purchase </p>
                          <p className="fw-semibold my-1">
                            {eq?.purchase_date}
                          </p>
                        </div>
                        <div className="d-flex flex-wrap justify-content-between align-items-center custom-card-sm ">
                          <p className="small my-1">Warranty</p>
                          <p className="fw-semibold my-1">
                            {eq?.warranty_expiry}
                          </p>
                        </div> */}
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <NotFound
                  paragraphText={
                    "No Equipments Yet. All your Equipments will appear here once you get started."
                  }
                />
              )
            ) : filteredEquipments.length > 0 ? (
              filteredEquipments.map((eq) => (
                <div className="col-12 col-lg-3">
                  <div
                    style={{
                      backgroundColor: "#F9F9F9",
                      height: "300px",
                      overflow: "auto",
                    }}
                    className="rounded-3 px-3 py-2 w-100"
                  >
                    <div className="d-flex justify-content-between align-items-center flex-wrap custom-card-sm gap-2 mt-1">
                      <div className="d-flex justify-content-center align-items-center custom-card-sm">
                        <IconButton
                          onClick={() => handleEditEquipment(eq)}
                          size="small"
                        >
                          <Edit />
                        </IconButton>
                      </div>
                      <div className="d-flex align-items-center gap-2">
                        <div className="cursor">
                          <IconButton
                            size="small"
                            color="error"
                            onClick={() => handleDeleteClick(eq.id)}
                          >
                            <DeleteOutlineOutlined />
                          </IconButton>
                        </div>
                      </div>
                    </div>
                    <div
                      onClick={() => navigate(`/AllEquipments/${eq.id}`)}
                      className="cursor"
                    >
                      <h6 className="fw-bold text-center my-1">
                        {eq?.model?.name}
                        <Tooltip
                          componentsProps={{
                            tooltip: { sx: { width: 150 } },
                          }}
                          title={eq?.notes}
                          placement="right"
                        >
                          <IconButton>
                            <Info sx={{ width: 20 }} />
                          </IconButton>
                        </Tooltip>
                      </h6>
                      <div className="d-flex flex-wrap justify-content-between align-items-center custom-card-sm ">
                        <p className="small my-1">Original S/N.</p>
                        <p className="fw-semibold my-1">
                          {eq?.manufacturer_serial_number}
                        </p>
                      </div>
                      <div className="d-flex flex-wrap justify-content-between custom-card-sm ">
                        <p className="small my-1">ESTBN S/N.</p>
                        <p className="fw-semibold my-1">
                          {eq?.internal_serial_number}
                        </p>
                      </div>
                      <div className="d-flex flex-wrap justify-content-between custom-card-sm ">
                        <p className="small my-1">Acquisition</p>
                        <p className="fw-semibold my-1">
                          {eq?.acquisition_type_display}
                        </p>
                      </div>
                      <div className="d-flex flex-wrap justify-content-between align-items-center custom-card-sm ">
                        <p className="small my-1">Status</p>
                        <p className="fw-semibold my-1">{eq?.status_display}</p>
                      </div>
                      <div className="d-flex flex-wrap justify-content-between align-items-center custom-card-sm ">
                        <p className="small my-1">Purchase </p>
                        <p className="fw-semibold my-1">{eq?.purchase_date}</p>
                      </div>
                      <div className="d-flex flex-wrap justify-content-between align-items-center custom-card-sm ">
                        <p className="small my-1">Warranty</p>
                        <p className="fw-semibold my-1">
                          {eq?.warranty_expiry}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <NotFound
                paragraphText={
                  "No Equipments found that match your selected filters."
                }
              />
            )}
          </div>
        )}
        {/* tables view  */}
        {viewMode === "table" && (
          <div className="data-grid-small">
            <Paper sx={{ height: "auto", width: "100%" }}>
              {rows.length > 0 ? (
                <DataGrid
             autoHeight
  rows={rows}
  columns={columns}
  paginationMode="server"
  rowCount={rowCount}
  paginationModel={paginationModel}
  pageSizeOptions={[5, 10, 15, 25, 50]}
 onPaginationModelChange={setPaginationModel}
  checkboxSelection
                  sx={{
                    border: 0,

                    "& .MuiDataGrid-cell": {
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    },

                    "& .MuiDataGrid-cellContent": {
                      py: 1,
                    },

                    "& .MuiDataGrid-virtualScroller": {
                      paddingBottom: "12px",
                    },
                  }}
                />
              ) : (
                <NotFound paragraphText="No Equipments found that match your selected filters." />
              )}
            </Paper>
          </div>
        )}
        {/* filter  */}
        {showFilter && (
          <div
            style={{
              position: "fixed",
              top: 0,
              right: 0,
              width: "300px",
              height: "100%",
              backgroundColor: "#fff",
              boxShadow: "-3px 0 8px rgba(0,0,0,0.1)",
              zIndex: 2000,
              padding: "20px",
              overflowY: "auto",
            }}
          >
            <h6 className="fw-bold mb-3">Filter Equipments</h6>

            <div className="mb-3">
              <h6>Status</h6>
              {equipmentsFormData?.status_options &&
                Object.entries(equipmentsFormData.status_options).map(
                  ([key, value]) => (
                    <div key={key} className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id={`status-${key}`}
                        checked={selectedStatuses.includes(key)}
                        onChange={() => handleStatusChange(key)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`status-${key}`}
                      >
                        {value}
                      </label>
                    </div>
                  ),
                )}
            </div>

            <div className="mb-3">
              <h6>Acquisition Type</h6>
              {equipmentsFormData?.acquisition_type_options &&
                Object.entries(equipmentsFormData.acquisition_type_options).map(
                  ([key, value]) => (
                    <div key={key} className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id={`acq-${key}`}
                        checked={selectedAcquisitions.includes(key)}
                        onChange={() => handleAcquisitionChange(key)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`acq-${key}`}
                      >
                        {value}
                      </label>
                    </div>
                  ),
                )}
            </div>

            <div className="d-flex justify-content-between mt-4">
              <button
                className="btn btn-light"
                onClick={() => {
                  setSelectedStatuses([]);
                  setSelectedAcquisitions([]);
                  setFilteredEquipments(null);
                  setShowFilter(false);
                }}
              >
                Reset
              </button>
              <button className="btn btn-dark" onClick={applyFilters}>
                Apply
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Tables;
